import simpleParallax from "simple-parallax-js";

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  var image = document.getElementsByClassName("parallax");
  // eslint-disable-next-line new-cap
  new simpleParallax(image, {
    delay: 0.6,
    transition: "cubic-bezier(0,0,0,1)",
  });
});
